// /* assets/c-variant-mobile.js */
// /* SPバリエーション用モーダル */

(function () {
  if (typeof window.initVariantModal === 'function') return;

  window.selectVariantById = function (vid) {
    try {
      document
        .querySelectorAll('input.formVariantId,[name="id"], select[name="id"]')
        .forEach((el) => (el.value = String(vid)));
    } catch (_) {}
  };

  const isMobile = () => window.matchMedia('(max-width:740px)').matches;
  const yen = (cents) => '¥' + (Number(cents) / 100).toLocaleString('ja-JP');
  const withTax = (s) => (/税込/.test(String(s||'')) ? s : (s ? `${s} （税込）` : s));
  const esc = (s) => (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s).replace(/(["'\\\]\[])/g,'\\$1');

  window.initVariantModal = function initVariantModal(cfg) {
    const secId = String(cfg.sectionId || '');
    const productId = String(cfg.productId || '');
    const allowUrlVariant = cfg.allowUrlVariant !== false;

    const root = document.querySelector(`#product-${productId}`) || document;

    let productData = {};
    try {
      const el = document.getElementById(`ProductJson-${secId}`);
      productData = el ? JSON.parse(el.textContent || '{}') : {};
    } catch (_) { productData = {}; }

    const variants = Array.isArray(productData.variants) ? productData.variants : [];
    const options  = Array.isArray(productData.options) ? productData.options : [];

    const findVariantById = (vid) => variants.find(v => String(v.id) === String(vid)) || null;

    const addToCartBtn = root.querySelector('#addToCart, .AddtoCart, [type="submit"].js-ajax-submit');
    const headerEl       = root.querySelector('[data-variant-header-text]');
    const triggerValueEl = root.querySelector('.c_variant-trigger [data-variant-trigger-text]');
    const triggerPriceEl = root.querySelector('.c_variant-trigger [data-variant-trigger-price]');

    const setATCState = (state) => {
      if (!addToCartBtn) return;
      const enable = () => { addToCartBtn.disabled = false; addToCartBtn.classList.remove('is-disabled'); };
      const disable = () => { addToCartBtn.disabled = true;  addToCartBtn.classList.add('is-disabled'); };
      if (state === 'unselected') { disable(); addToCartBtn.value = 'カートに入れる'; }
      else if (state === 'soldout') { disable(); addToCartBtn.value = 'SOLD OUT'; }
      else { enable(); addToCartBtn.value = 'カートに入れる'; }
    };

    const syncHiddenId = (vid) => {
      root.querySelectorAll('input.formVariantId').forEach(i => i.value = String(vid));
      root.querySelectorAll('input[name="id"]').forEach(i => i.value = String(vid));
      root.querySelectorAll('select[name="id"]').forEach(sel => sel.value = String(vid));
    };

    const syncThemePickers = (variant) => {
      const optionName  = cfg.firstOptionName || options[0] || '';
      const optionValue = variant && variant.options ? variant.options[0] : undefined;
      if (!optionName || optionValue == null) return;
      const swSel = `input.swatches__form--input[name="options[${esc(optionName)}]"][value="${esc(optionValue)}"]`;
      const swIn  = root.querySelector(swSel);
      if (swIn) { swIn.checked = true; swIn.dispatchEvent(new Event('change',{bubbles:true})); return; }
      const sel = root.querySelector(`#Option-${secId}-0`);
      if (sel) { sel.value = optionValue; sel.dispatchEvent(new Event('change',{bubbles:true})); }
    };

    const updateTriggerText = (v) => {
      if (!v) {
        if (headerEl)       headerEl.textContent       = '未選択';
        if (triggerValueEl) triggerValueEl.textContent = '商品を選択してください';
        if (triggerPriceEl) triggerPriceEl.textContent = '';
        return;
      }
      if (headerEl)       headerEl.textContent       = v.title;
      if (triggerValueEl) triggerValueEl.textContent = v.title;
      if (triggerPriceEl) triggerPriceEl.textContent = withTax(yen(v.price));
    };

    const renderHeaderPrice = (v) => {
      const priceRoot = root.querySelector('#product-price') || root.querySelector('.price');
      if (!priceRoot || !v) return;
      const regular = priceRoot.querySelector('[data-regular-price]') || priceRoot.querySelector('.price-item--regular');
      const sale    = priceRoot.querySelector('[data-sale-price]')    || priceRoot.querySelector('.price-item--sale');
      const onSale  = Number(v.compare_at_price) > Number(v.price);
      const pTxt    = withTax(yen(v.price));
      const cTxt    = withTax(yen(v.compare_at_price));
      if (onSale && sale) { sale.textContent = pTxt; if (regular) regular.textContent = cTxt; priceRoot.classList.add('price--on-sale'); }
      else { if (regular) regular.textContent = pTxt; if (sale) sale.textContent=''; priceRoot.classList.remove('price--on-sale'); }
    };

    const getFlickity = () => {
      if (!cfg.switchImage) return null;
      const main = root.querySelector(cfg.carouselSelector || `.js-carousel-main`);
      if (!main) return null;
      return (window.Flickity && window.Flickity.data && window.Flickity.data(main)) || main._flickity || null;
    };
    const selectMediaById = (mid) => {
      if (!cfg.switchImage || !mid) return false;
      const cellSel = cfg.cellSelector || '.js-main-carousel-cell';
      const idAttr  = cfg.cellIdAttr  || 'data-image-id';
      const idxAttr = cfg.slideIndexAttr || 'data-slide-index';
      const idStr = String(mid);
      const cell = root.querySelector(`${cellSel}[${idAttr}="${idStr}"]`)
             || root.querySelector(`[data-media-id="product-template-${idStr}"]`)?.closest(cellSel);
      if (!cell) return false;
      let index = parseInt(cell.getAttribute(idxAttr), 10);
      if (isNaN(index)) index = Array.from(root.querySelectorAll(cellSel)).indexOf(cell);
      const flkty = getFlickity();
      if (flkty?.select) { flkty.select(index, false, true); return true; }
      root.querySelectorAll(`${cellSel}.is-selected`).forEach(el => el.classList.remove('is-selected'));
      cell.classList.add('is-selected');
      const active = root.querySelector('.product-media-container.image.active-slide');
      if (active) active.classList.remove('active-slide');
      const pmc = cell.querySelector('.product-media-container.image');
      if (pmc) pmc.classList.add('active-slide');
      return true;
    };

    const pushVariantToUrlAndStore = (vid) => {
      try { const url = new URL(location.href); url.searchParams.set('variant', vid); history.replaceState({},'',url.toString()); } catch(_){}
      try { sessionStorage.setItem(`lastVariant:${productId}`, String(vid)); } catch(_){}
    };

    // SPは未選択
    const resolveInitialVariant = ()=> {
      let hasUrl = false, urlVid = null;
      if (allowUrlVariant) { try { urlVid = new URL(location.href).searchParams.get('variant'); hasUrl = !!urlVid; } catch(_){} }
      let wantRestore = false;
      try { wantRestore = sessionStorage.getItem(`restoreOnNextView:${productId}`) === '1'; } catch(_){}
      if (hasUrl) { const v = findVariantById(urlVid); if (v) return v; }
      if (wantRestore) {
        try { const last = sessionStorage.getItem(`lastVariant:${productId}`); if (last) { const v = findVariantById(last); if (v) return v; } } catch(_){}
        return variants.find(v=>v.available) || variants[0] || null;
      }
      if (isMobile()) return null; // SPは未選択
      return variants.find(v=>v.available) || variants[0] || null; // PCは自動選択
    };

    const notifyForms = (variant) => {
      root.querySelectorAll('[data-product-form]').forEach(form => {
        form.dispatchEvent(new CustomEvent('product:variant-change',{bubbles:true, detail:{variant}}));
        form.dispatchEvent(new Event('change',{bubbles:true}));
      });
    };

    const applyVariantEverywhere = (v, {pushUrl=true, skipImage=false} = {}) => {
      if (!v) return;
      syncHiddenId(v.id);
      syncThemePickers(v);
      updateTriggerText(v);
      renderHeaderPrice(v);
      notifyForms(v);
      if (!v.available) setATCState('soldout'); else setATCState('ready');
      if (!skipImage && v.featured_media?.id) selectMediaById(v.featured_media.id);
      if (pushUrl) pushVariantToUrlAndStore(v.id);
    };

    const initial = resolveInitialVariant();
    if (initial) {
      applyVariantEverywhere(initial, { pushUrl: allowUrlVariant });
      if (initial.featured_media?.id) selectMediaById(initial.featured_media.id);
      try { sessionStorage.removeItem(`restoreOnNextView:${productId}`); } catch(_){}
    } else {
      updateTriggerText(null);
      setATCState('unselected');
      syncHiddenId('');
    }

    window.addEventListener('pageshow', () => {
      if (!allowUrlVariant) return;
      let vid = null; try { vid = new URL(location.href).searchParams.get('variant'); } catch(_){}
      if (!vid) return;
      const v = findVariantById(vid);
      if (v) applyVariantEverywhere(v, {pushUrl:false});
    });

    // モーダル
    const modal   = document.getElementById(`VariantModal-${secId}`);
    const trigger = root.querySelector('[data-variant-modal-trigger]');
    const ANIM_MS = 320;

    const uncheckAllRadios = () => {
      if (!modal) return;
      modal.querySelectorAll('input[type="radio"]:not(.c-variant-dummy)').forEach(r => {
        r.checked = false;
        r.removeAttribute('checked');
      });
      modal.querySelectorAll('.c_variant-item[aria-selected]')
           .forEach(li => li.setAttribute('aria-selected','false'));
    };

    // ラジオグループにダミーを挿入し
    const ensureDummyChecked = () => {
      if (!modal) return;
      const firstReal = modal.querySelector('input.c_variant-item__radio[name][type="radio"]:not(.c-variant-dummy)');
      if (!firstReal) return;
      const groupName = firstReal.getAttribute('name');
      let dummy = modal.querySelector(`input.c-variant-dummy[type="radio"][name="${groupName}"]`);
      if (!dummy) {
        dummy = document.createElement('input');
        dummy.type = 'radio';
        dummy.name = groupName;
        dummy.value = '';
        dummy.setAttribute('tabindex','-1');
        dummy.setAttribute('aria-hidden','true');
        dummy.className = 'c_variant-item__radio c-variant-dummy';
        dummy.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;';
        const list = modal.querySelector('.c_variant-list') || modal;
        list.insertBefore(dummy, list.firstChild);
      }
      dummy.checked = true;
    };

    const markModalSelection = (variantId) => {
      if (!modal) return;
      modal.querySelectorAll('.c_variant-item[aria-selected]').forEach(li => li.setAttribute('aria-selected','false'));
      const radio = variantId ? modal.querySelector(`input[type="radio"][value="${variantId}"]`) : null;
      if (radio) {
        radio.checked = true;
        radio.setAttribute('checked','checked');
        const li = radio.closest('.c_variant-item');
        if (li) li.setAttribute('aria-selected','true');
      }
    };

    const open = () => {
      if (!modal) return;
      modal.hidden = false;
      trigger && trigger.setAttribute('aria-expanded','true');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => { modal.classList.add('is-open'); });

      const cur = root.querySelector('input.formVariantId,[name="id"], select[name="id"]')?.value;

      if (cur) {
        uncheckAllRadios();
        markModalSelection(String(cur));
      } else {
        ensureDummyChecked();
        uncheckAllRadios();
        updateTriggerText(null);
        setATCState('unselected');
      }

      setTimeout(() => {
        const focusable =
          modal.querySelector('input[type="radio"]:not(.c-variant-dummy):not(:disabled)') ||
          modal.querySelector('[data-variant-modal-close]');
        focusable && focusable.focus();
      }, ANIM_MS);
    };

    const close = () => {
      if (!modal) return;
      modal.classList.remove('is-open');
      trigger && trigger.setAttribute('aria-expanded','false');
      const finish = () => { modal.hidden = true; document.documentElement.style.overflow = ''; trigger && trigger.focus(); };
      let done = false;
      const onEnd = (e) => { if (done) return; if (e.target === modal) { done = true; modal.removeEventListener('transitionend', onEnd); finish(); } };
      modal.addEventListener('transitionend', onEnd);
      setTimeout(() => { if (!done) { modal.removeEventListener('transitionend', onEnd); finish(); } }, ANIM_MS + 50);
    };

    if (trigger && modal) {
      trigger.addEventListener('click', open);
      modal.addEventListener('click', (e)=> {
        if (e.target.matches('[data-variant-modal-close], .c_variant-modal__overlay')) close();
      });
      window.addEventListener('keydown', (e)=>{ if (e.key === 'Escape' && !modal.hidden) close(); });

      modal.addEventListener('change', (e) => {
        const input = e.target;
        if (!input || input.type !== 'radio' || input.classList.contains('c-variant-dummy')) return;
        const v = findVariantById(input.value);
        if (!v) return;
        applyVariantEverywhere(v, {pushUrl:true});
        markModalSelection(String(v.id));
        close();
      });

      modal.addEventListener('click', (e) => {
        const input = e.target.closest('label')?.querySelector('input[type="radio"]')
                   || (e.target.matches('input[type="radio"]') ? e.target : null);
        if (!input || input.classList.contains('c-variant-dummy')) return;
        const v = findVariantById(input.value);
        if (!v) return;
        if (!input.checked) { input.checked = true; }
        applyVariantEverywhere(v, {pushUrl:true});
        markModalSelection(String(v.id));
        close();
      });
    }

    const optionsNames = options;
    const pickVariantFromDesktopPickers = () => {
      const form = root.querySelector('form[action*="/cart/add"]') || root;
      const chosen = [];
      optionsNames.forEach((name, idx) => {
        const sw = form.querySelector(`input.swatches__form--input[name="options[${name}]"]:checked`);
        if (sw) chosen[idx] = sw.value;
      });
      if (chosen.length === 0 || chosen.every(v => v == null)) {
        optionsNames.forEach((_, idx) => {
          const sel = form.querySelector(`#Option-${secId}-${idx}`);
          if (sel) chosen[idx] = sel.value;
        });
      }
      if (chosen.length === 0 || chosen.every(v => v == null)) return null;
      return variants.find(v => (v.options || []).every((opt, i) => String(opt) === String(chosen[i])));
    };

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!root.contains(t)) return;
      if (t.matches('input.swatches__form--input, select[id^="Option-"]')) {
        const v = pickVariantFromDesktopPickers();
        if (v) {
          applyVariantEverywhere(v, {pushUrl:true});
          markModalSelection(String(v.id));
        }
      }
    });

    root.querySelectorAll('form[action*="/cart/add"]').forEach(f=>{
      f.addEventListener('submit',()=>{
        const vid = (root.querySelector('input.formVariantId,[name="id"], select[name="id"]')||{}).value;
        if (vid) {
          try{
            sessionStorage.setItem(`lastVariant:${productId}`, String(vid));
            sessionStorage.setItem(`restoreOnNextView:${productId}`, '1');
          }catch(_){}
        }
      });
    });
  };
})();
